// src/pages/SalesReturnLedger/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Typography } from "antd";
import SalesReturnLedgerFilters from "./components/SalesReturnLedgerFilters";
import SalesReturnLedgerTable from "./components/SalesReturnLedgerTable";
import ReportDom from "../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";

const { Title } = Typography;

const SalesReturnLedger = () => {
  const { message } = App.useApp();
  const { filters } = useSelector((state) => state.salesReturnLedger);

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Sales Return Ledger Report",
    removeAfterPrint: true,
  });

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Title level={4} style={{ margin: 0 }}>
              Sales Return Account Ledger
            </Title>
          }
          extra={
            <Button
              type="primary"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
            >
              Print
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <SalesReturnLedgerFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <SalesReturnLedgerTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Sales Return Ledger Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <SalesReturnLedgerTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default SalesReturnLedger;
